export default __webpack_public_path__ + "static/media/menu_photo1@2x.60fca18d.png";